import React from 'react';

export const PrivateRoute = ({ element: Component, isAuthenticated, ...rest }) => {
  // Temporarily bypass authentication check for development
  return Component;
};

export default PrivateRoute;